import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {TextStyle, TextContainer, DisplayText} from '@shopify/polaris';
import classNames from 'classnames';
import {changeStep} from '../../actions/steps';

export const Classes = {
  BREADCRUMB: 'sm-breadcrumb',
  VISITED: 'sm-breadcrumb--visited',
  ACTIVE: 'sm-breadcrumb--active',
};

class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.renderBreadcrumbs = this.renderBreadcrumbs.bind(this);
    this.renderBreadcrumb = this.renderBreadcrumb.bind(this);
  }

  render() {
    return (
      <div className="type-container">
        <TextContainer>
          {this.renderService()}
          {this.renderBreadcrumbs()}
        </TextContainer>
      </div>
    );
  }

  renderService() {
    const {breadcrumbs, currentStepIndex} = this.props;
    const {serviceHandle, services} = this.props;

    return (
      <TextContainer spacing={'tight'}>
        <DisplayText size="small">
          <TextStyle variation="subdued">
            {services[serviceHandle].label}
            <span className="hide-on-desktop">
              {' '}
              &gt; Step {currentStepIndex + 1} of {breadcrumbs.length}
            </span>
          </TextStyle>
        </DisplayText>
        <p>{services[serviceHandle].description}</p>
      </TextContainer>
    );
  }

  renderBreadcrumbs() {
    const {breadcrumbs} = this.props;

    return (
      <nav className="sm-breadcrumbs hide-on-tablet" aria-label="Breadcrumb">
        {breadcrumbs.map(this.renderBreadcrumb)}
      </nav>
    );
  }

  renderBreadcrumb(breadcrumb, index) {
    const {breadcrumbs, currentStepIndex} = this.props;
    const breadcrumbIndex = breadcrumbs.indexOf(breadcrumb);
    const stepIndex = index;
    const isVisited = breadcrumbIndex < currentStepIndex;
    const isActive = breadcrumbIndex === currentStepIndex;
    const breadcrumbClass = classNames(
      'Polaris-Link',
      'sm-breadcrumb',
      this.props.className,
      {
        [Classes.VISITED]: isVisited,
        [Classes.ACTIVE]: isActive,
      }
    );
    const onClick = this.props.changeStep.bind(this, stepIndex);

    return (
      <a
        href={isVisited || isActive ? `#${breadcrumb}` : null}
        key={`${breadcrumb}-${stepIndex}`}
        className={breadcrumbClass}
        disabled={!isVisited && !isActive}
        onClick={onClick} // eslint-disable-line react/jsx-no-bind
        aria-current={isActive ? 'step' : null}
      >
        {stepIndex + 1}. {breadcrumb}
      </a>
    );
  }
}

function mapStateToProps(state) {
  const {
    progress: {breadcrumbs, currentStepIndex},
    entities: {services},
    context: {serviceHandle},
  } = state;

  return {
    breadcrumbs,
    currentStepIndex,
    services,
    serviceHandle,
  };
}

function mapStateToDispatch(dispatch) {
  return {
    changeStep: index => {
      dispatch(changeStep(index));
    },
  };
}

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Navigation);

Navigation.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.string.isRequired),
  currentStepIndex: PropTypes.number,
  changeStep: PropTypes.func.isRequired,
  serviceHandle: PropTypes.string.isRequired,
  services: PropTypes.object,
};
